import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import SearchField from '../FormLegacy/FormFieldsV2/SearchField'

import { getSurveyStatuses } from './helpers'

const SurveyNavbar = ({ selectedTab, changeTab, search, handleSearch }) => {
  const { t } = useTranslation(['surveys'])
  return (
    <div className="ctp-survey__navbar">
      <div className="ctp-survey__navbar-tabs">
        {getSurveyStatuses(t).map((tab) => (
          <div
            className={`ctp-survey__navbar-tab ${tab.value === selectedTab.value ? 'active' : ''}`}
            key={tab.value}
            onClick={() => changeTab(tab)}
          >
            {tab.text}
          </div>
        ))}
      </div>
      <SearchField
        placeholder={t('surveys:table.searchPlaceholder')}
        value={search}
        onChange={(e) => handleSearch(e.target.value)}
      />
    </div>
  )
}

SurveyNavbar.propTypes = {
  selectedTab: PropTypes.object,
  changeTab: PropTypes.func,
  search: PropTypes.string,
  handleSearch: PropTypes.func,
}

export default SurveyNavbar
